module.exports = __webpack_public_path__ + "static/media/19ESCAP36.7b6baa48.jpg";